import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export var ExpandableLabelBody = function ExpandableLabelBody(_ref) {
  var className = _ref.className,
      expanded = _ref.expanded,
      children = _ref.children;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];

  var contentRef = useRef(null);
  var classes = classnames("ptr-ExpandableLabelBody", {
    'is-expanded': expanded
  }, className);
  useEffect(function () {
    var _contentRef$current;

    setContentHeight(contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getBoundingClientRect().height);
  }, []);
  var bodyStyle = {};

  if (contentHeight && expanded) {
    bodyStyle.height = "".concat(contentHeight, "px");
  }

  return /*#__PURE__*/_jsx("div", {
    className: classes,
    style: bodyStyle,
    children: /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      children: children
    })
  });
};
ExpandableLabelBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  expanded: PropTypes.bool
};
export default ExpandableLabelBody;